import React from "react";
import { View, ViewStyle } from "react-native";
import { buttonStyles as styles } from "./styles";

type ButtonProps = {
  enabled: boolean;
  customButtonStyles?: {
    radioButtonContainer?: ViewStyle;
    radioButtonEnabled?: ViewStyle;
    radioButtonDisabled?: ViewStyle;
  };
};

const Button = ({ enabled, customButtonStyles }: ButtonProps): JSX.Element => {
  return (
    <View style={styles.buttonContainer}>
      <View
        style={[
          styles.radioButtonContainer,
          customButtonStyles?.radioButtonContainer,
        ]}
      >
        <View
          style={
            enabled
              ? [
                  styles.radioButtonEnabled,
                  customButtonStyles?.radioButtonEnabled,
                ]
              : [
                  styles.radioButtonDisabled,
                  customButtonStyles?.radioButtonDisabled,
                ]
          }
        />
      </View>
    </View>
  );
};

export default Button;
